const h2Regex = /^(##\s+)(.*)$/gm;
export function extractTableOfContents(markdownContent: any) {
  const tableOfContents = [];
  let match;
  while ((match = h2Regex.exec(markdownContent)) !== null) {
    const headingText = match[2].trim();
    const anchor = headingText.toLowerCase().replace(/[?'"]/g, '').replace(/[\s.'-]+/g, '-');
    tableOfContents.push({
      heading: headingText,
      anchor: anchor
    });
  }
  return tableOfContents;
}